import { render, staticRenderFns } from "./HowItWorksTokens.vue?vue&type=template&id=10b57155&scoped=true"
import script from "./HowItWorksTokens.vue?vue&type=script&lang=js"
export * from "./HowItWorksTokens.vue?vue&type=script&lang=js"
import style0 from "./HowItWorksTokens.vue?vue&type=style&index=0&id=10b57155&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10b57155",
  null
  
)

export default component.exports